import React from "react";
import { NavLink } from "react-router-dom";

const navList = [
  {
    url: "/samples",
    image: "/img/samples.svg",
    title: "Samples",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
      <g fill="#F1F3F5" fill-rule="evenodd" stroke="#868E96" stroke-linecap="round" stroke-linejoin="round" transform="translate(1 1)">
        <rect width="4.667" height="4.667"/>
        <rect width="4.667" height="4.667" x="7.333"/>
        <rect width="4.667" height="4.667" x="7.333" y="7.333"/>
        <rect width="4.667" height="4.667" y="7.333"/>
      </g>
    </svg>`
  },
  {
    url: "/analysis",
    image: "/img/analysis.svg",
    title: "Analysis",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16">
      <g fill="#F1F3F5" fill-rule="evenodd" stroke="#868E96" transform="translate(1 .333)">
        <rect width="12" height="14" y=".667" rx="1"/>
        <path stroke-linecap="round" d="M5.33333333 4.66666667L9 4.66666667M3 4.66666667L3.33333333 4.66666667M3 7.66666667L3.33333333 7.66666667M3 10.6666667L3.33333333 10.6666667M5.33333333 7.66666667L9 7.66666667M5.33333333 10.6666667L9 10.6666667"/>
      </g>
    </svg>`
  },
  {
    url: "/libraries",
    image: "/img/libraries.svg",
    title: "Libraries",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16">
      <g fill="#F1F3F5" fill-rule="evenodd" stroke="#868E96" transform="translate(.333 1.333)">
        <path d="M1.33333333,0 L6.58798976,-1.11022302e-16 C6.85340176,-1.59777695e-16 7.10792665,0.105511791 7.29549536,0.293292263 L10.7075056,3.70915461 C10.894798,3.89665845 11,4.15084135 11,4.41586235 L11,12.3333333 C11,12.8856181 10.5522847,13.3333333 10,13.3333333 L1.33333333,13.3333333 C0.781048584,13.3333333 0.333333333,12.8856181 0.333333333,12.3333333 L0.333333333,1 C0.333333333,0.44771525 0.781048584,1.01453063e-16 1.33333333,0 Z"/>
        <polyline stroke-linejoin="round" points="7 0 7 4 11 4"/>
        <path stroke-linecap="round" d="M8.43751106 8.66666667L3.03961787 8.66666667M5.73856447 11.3656133L5.73856447 5.96772007"/>
      </g>
    </svg>`
  },
  {
    url: "/filters",
    image: "/img/filters.svg",
    title: "Filters",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15">
      <path fill="#F1F3F5" fill-rule="evenodd" stroke="#868E96" d="M0.966666667,0.666666667 L10.3666667,0.666666667 C10.8084945,0.666666667 11.1666667,1.02483887 11.1666667,1.46666667 L11.1666667,3.76666667 C11.1666667,4.01847251 11.0481113,4.25558316 10.8466667,4.40666667 L7.48666667,6.92666667 C7.28522199,7.07775017 7.16666667,7.31486082 7.16666667,7.56666667 L7.16666667,12.671853 C7.16666667,13.1136808 6.80849447,13.471853 6.36666667,13.471853 C6.20872668,13.471853 6.05432052,13.4251026 5.92290651,13.3374932 L4.52290651,12.4041599 C4.30034757,12.2557873 4.16666667,12.0060022 4.16666667,11.7385197 L4.16666667,7.56666667 C4.16666667,7.31486082 4.04811134,7.07775017 3.84666667,6.92666667 L0.486666667,4.40666667 C0.285221993,4.25558316 0.166666667,4.01847251 0.166666667,3.76666667 L0.166666667,1.46666667 C0.166666667,1.02483887 0.524838867,0.666666667 0.966666667,0.666666667 Z" transform="translate(.333 .333)"/>
    </svg>`
  },
  {
    url: "/publications",
    image: "/img/publications.svg",
    title: "Publications",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16">
      <g fill="#F1F3F5" fill-rule="evenodd" stroke="#868E96" transform="translate(.333 1.333)">
        <path d="M1.33333333,0 L6.58798976,-1.11022302e-16 C6.85340176,-1.59777695e-16 7.10792665,0.105511791 7.29549536,0.293292263 L10.7075056,3.70915461 C10.894798,3.89665845 11,4.15084135 11,4.41586235 L11,12.3333333 C11,12.8856181 10.5522847,13.3333333 10,13.3333333 L1.33333333,13.3333333 C0.781048584,13.3333333 0.333333333,12.8856181 0.333333333,12.3333333 L0.333333333,1 C0.333333333,0.44771525 0.781048584,1.01453063e-16 1.33333333,0 Z"/>
        <polyline stroke-linejoin="round" points="7 0 7 4 11 4"/>
        <path stroke-linecap="round" d="M8.33333333 7.33333333L3 7.33333333M8.33333333 10L3 10"/>
      </g>
    </svg>`
  }
];

const Header = props => {
  return (
    <header className="header">
      <a className="logo" href="/">
        <img className="logo__pic" src="/img/qiagen.svg" alt="" />
        <span className="logo__title">Variant Analysis</span>
      </a>
      <nav className="nav">
        {navList.map((item, index) => (
          <NavLink
            className="nav__item"
            activeClassName="active"
            to={item.url}
            key={index}
          >
            <div className="nav__preview" dangerouslySetInnerHTML={{__html: item.icon}}></div>
            <div className="nav__title">{item.title}</div>
          </NavLink>
        ))}
      </nav>
      <div className="header__right">
        <a className="header__send" href="/">Send feedback</a>
        <a className="header__link" href="/">Rupert</a>
      </div>
    </header>
  );
};

export default Header;
